import $ from 'jquery';
import LP from '../0-lp';

LP.dlgPage = {
  storedTabText: '',
  orgBeforeSubmit: '',
  orgAfterSubmit: '',
  dispatching: false,

  prepare: function (selector, params) {
    LP.dlgPage.orgBeforeSubmit = params.beforeSubmit;
    LP.dlgPage.orgAfterSubmit = params.afterSubmit;

    $(selector).click(function () {
      if (!$(this).is('[disabled]')) {
        LP.Dialog.open(
          $.extend(params, {
            name: 'page',
            ajax: $(this).attr('url'),
            request: $(this).attr('url_params'),
            title: this.title,
            width: 970,
            height: 600,
            sizeable: true,
            onLoad: LP.dlgPage.onLoad,
            beforeSubmit: LP.dlgPage.beforeSubmit,
            afterSubmit: LP.dlgPage.onSubmit,
            onClose: LP.dlgPage.onClose,
            dialogClass: 'lp-tabs-horizontal',
          })
        );
      }
      return false;
    });
  },

  onLoad: function () {
    LP.Dialog.initTabs({
      name: '#pageDialogTabs',
      onTabLoaded: LP.dlgPage.onTabLoaded,
      beforeTabChanged: LP.dlgPage.beforeTabChanged,
      afterTabChanged: LP.dlgPage.afterTabChanged,
      cache: true,
      loaderType: 'rotate-snake',
      loadedType: 'arrow',
    });
    LP.dlgPage.onGeneralTabLoaded();
    LP.dlgPage.onSettingsTabLoaded();
    LP.dlgPageJumps.onLoad();
    LP.dlgPageVisible.onLoad();
  },

  onClose: function () {
    var pageId = $('#pageId').val();
    window.Browser.send('backend/closeEditDialog/', 'pageId=' + pageId);
    return false;
  },

  beforeSubmit: function (json) {
    LP.Dialog.hideErrors();
    LP.dlgPageJumps.beforeSubmit();
    LP.dlgPageVisible.beforeSubmit();
    var result = LP.dlgPage.savePageTab(false);

    if (LP.dlgPage.orgBeforeSubmit) LP.dlgPage.orgBeforeSubmit(json);
    return result;
  },

  onSubmit: function (json) {
    if (LP.dlgPage.orgAfterSubmit) return LP.dlgPage.orgAfterSubmit(json);
    return true;
  },

  savePageTab: function () {
    var tabResult = false;
    var url = 'backend/savePageTab/';
    var params = $('#pageForm').serialize();
    const $panel = $('#pageDialogTabs');
    $panel.timedLoader(0); // sieht man nich so gut, wegen der sync-browser-requests
    window.Browser.send(
      url,
      params,
      function (json) {
        $panel.timedLoader(false);
        LP.Dialog.showError(json, $('.tabError', LP.Dialog.getInstance(), false));
        tabResult = true;
        return true;
      },
      function (json) {
        $panel.timedLoader(false);
        LP.Dialog.showError(json, $('.tabError', LP.Dialog.getInstance(), false));
        tabResult = false;
        return true;
      },
      false // send syncron!
    );

    return tabResult;
  },

  beforeTabChanged: function (ui, refresh) {
    LP.Dialog.hideErrors();
    var tabname = LP.Dialog.getTabName();
    if (tabname == 'visibility') LP.filters.removeEmptyTerms($('#fs-page-visibility'));
    if (tabname == 'jumps') LP.filters.removeEmptyFilters($('#fs-page-jumps'));
    var tabResult = LP.dlgPage.savePageTab(refresh);

    return tabResult;
  },

  afterTabChanged: function () {
    return true;
  },

  onTabLoaded: function () {},

  onGeneralTabLoaded: function () {
    $('input[name="pageGen[isEndpage]"]').change(LP.dlgPage.endPageToggle);
    LP.dlgPage.initReactTargetUrlInputs();
  },

  endPageToggle: function () {
    var checked = $(this).is(':checked');
    if (!checked) {
      $('#endPageTargetTD').removeClass('hide').hide();
    } else {
      $('#endPageTargetTD').addClass('hide').show();
    }
  },

  initReactTargetUrlInputs: function () {
    const targetUrlDivs = document.querySelectorAll('.endPageTargetUrl');
    Array.from(targetUrlDivs).forEach((targetUrlDiv) => {
      if (!targetUrlDiv.getAttribute('data-init')) {
        window.reactPortals.addReactUrlInputField(targetUrlDiv);
        targetUrlDiv.setAttribute('data-init', true);
      }
    });
  },

  onSettingsTabLoaded: function () {
    return true;
  },
};

LP.dlgPageVisible = {
  dispatching: false,

  prepare: function (selector, params) {
    LP.dlgPageVisible.orgBeforeSubmit = params.beforeSubmit;
    LP.dlgPageVisible.orgAfterSubmit = params.afterSubmit;

    $(selector).click(function () {
      if (!$(this).is('[disabled]')) {
        LP.Dialog.open(
          $.extend(params, {
            name: 'pageVisible',
            ajax: $(this).attr('url'),
            request: $(this).attr('url_params'),
            title: this.title,
            width: 800,
            height: 700,
            sizeable: true,
            onLoad: LP.dlgPageVisible.onLoad,
            beforeSubmit: LP.dlgPageVisible.beforeSubmit,
            afterSubmit: LP.dlgPageVisible.onSubmit,
            onClose: LP.dlgPageVisible.onClose,
          })
        );
      }
      return false;
    });
  },

  onLoad: function () {
    LP.filters.init({root: $('#fs-page-visibility')});
  },

  beforeSubmit: function () {
    LP.filters.removeEmptyTerms($('#fs-page-visibility'));
    return true;
  },

  onClose: function () {
    var pageId = $('#pageId').val();
    window.Browser.send('backend/closeEditDialog/', 'pageId=' + pageId);
    return false;
  },
};

LP.dlgPageJumps = {
  dispatching: false,

  prepare: function (selector, params) {
    LP.dlgPageJumps.orgBeforeSubmit = params.beforeSubmit;
    LP.dlgPageJumps.orgAfterSubmit = params.afterSubmit;

    $(selector).click(function () {
      if (!$(this).is('[disabled]')) {
        LP.Dialog.open(
          $.extend(params, {
            name: 'pageJump',
            ajax: $(this).attr('url'),
            request: $(this).attr('url_params'),
            title: this.title,
            width: 800,
            height: 700,
            sizeable: true,
            onLoad: LP.dlgPageJumps.onLoad,
            beforeSubmit: LP.dlgPageJumps.beforeSubmit,
            afterSubmit: LP.dlgPageJumps.onSubmit,
            onClose: LP.dlgPageJumps.onClose,
          })
        );
      }
      return false;
    });
  },

  onLoad: function () {
    LP.filters.init({root: $('#fs-page-jumps'), onUpdate: LP.dlgPageJumps.checkJumps});
  },

  beforeSubmit: function () {
    LP.filters.removeEmptyFilters($('#fs-page-jumps'));

    // correct urls
    $('#pageForm .pageURL').each(function () {
      var url = $(this);
      var value = url.val();
      if (value) {
        value = LP.dlgPageJumps.validateURL(value);
        url.val(value);
      }
    });
    $('#pageForm .pageAltURL').each(function () {
      var url = $(this);
      var value = url.val();
      if (value) {
        value = LP.dlgPageJumps.validateURL(value);
        url.val(value);
      }
    });

    return true;
  },

  onClose: function () {
    var pageId = $('#pageId').val();
    window.Browser.send('backend/closeEditDialog/', 'pageId=' + pageId);
    return false;
  },

  checkJumps: function () {
    if (LP.dlgPageJumps.dispatching) {
      return;
    }

    LP.dlgPageJumps.dispatching = true;
    let filters = $('#fs-page-jumps'); // if no jumps exists, add one
    //var filterItems = $('.lp-filter-items .lp-filter',filters);
    //if( filterItems.length == 0 ) LP.filters.addFilter(filters);

    /**
     * Starts the external URL input or clears it, as needed
     */
    var setupPageSelect = function (select, inputType) {
      let parent = select.parent();
      let url_editor = $('.' + inputType + 'URLEditor', parent);
      if (select.val() == '-99') {
        let url_input = $('.' + inputType + 'URL', parent);
        LP.dlgPageJumps.initJumpURLEditor(url_editor, url_input);
      } else {
        LP.dlgPageJumps.clearJumpURLEditor(url_editor);
      }
    };

    $('.pageSelect', filters).each(function (index, select) {
      select = $(select);
      select.unbind('change').change(function () {
        setupPageSelect(select, 'page');
      });
      setupPageSelect(select, 'page');
    });

    $('.pageAltSelect', filters).each(function (index, select) {
      select = $(select);
      select.unbind('change').change(function () {
        setupPageSelect(select, 'pageAlt');
      });
      setupPageSelect(select, 'pageAlt');
    });

    LP.dlgPageJumps.dispatching = false;
  },

  initJumpURLEditor: function (editor_element, url_input) {
    /**
     * When the URL Editor is not initially loaded there is no input
     * But we rely on the input name [] to be in the right order to know which input is associated with which jump
     * So a hidden input is created by default which we then delete once the JumpURLEditor is loaded
     * This makes the POST request consistent and fixes SUP-545 and LP-2694
     */
    if (url_input) {
      url_input.remove();
    }

    Array.from(editor_element).forEach((pageUrlDiv) => {
      if (!pageUrlDiv.getAttribute('data-init')) {
        window.reactPortals.addReactUrlInputField(pageUrlDiv);
        pageUrlDiv.setAttribute('data-init', true);
      }
    });
    editor_element.parent().show();
  },

  validateURL: function (value) {
    return $('<span>' + value + '</span>').text(); // clear all html stuff
  },

  clearJumpURLEditor: function (editor_element) {
    editor_element.parent().hide();
  },
};
